



function validateKont(){
    //trace("plausi");
    kontaktok=true;



    checkKontaktFiled( '#vorname' );	// Vorname
    checkKontaktFiled( '#nachname' );	//Nachname
    checkKontaktFiled( '#email' );	//E-Mail
    checkKontaktFiled( '#anliegen' );	//E-Mail

    infoConfirm( '#confirmation' );	//Datenschutz-Zustimmung
    if(kontaktok) sendKontakt();
    else $('.errorFeedBack').css('visibility', 'visible');
}


function checkKontaktFiled( _id ){

    if ( !$( _id ).hasClass('fgBlack') ){
        $( _id ).addClass('error')
        kontaktok = false
    }

}

function sendKontakt(){
    $('.errorFeedBack').css('visibility', 'hidden');

    $('#kontaktform').submit();
}


function validateTextField( _id, _val ){

    if (_id == "email" ){
        if( _val.length > 5  ) 	{
            if( validateEmail( _val ) ){
                if( !$('#'+_id).hasClass('fgBlack') ) $('#'+_id).addClass('fgBlack validatedBorder').removeClass("error");

            }else{
                if( $('#'+_id).hasClass('fgBlack') ) $('#'+_id).removeClass('fgBlack validatedBorder');
            }
        }
    }  else {
        if( _val.length > 2  ){
            if( !$('#'+_id).hasClass('fgBlack') ) $('#'+_id).addClass('fgBlack validatedBorder').removeClass("error");
        }else{
            if( $('#'+_id).hasClass('fgBlack') ) $('#'+_id).removeClass('fgBlack validatedBorder');
        }

        // $('#aboBTN p').addClass('bgDarkGrey');

    }

}

// E-Mail validieren
function validateEmail($email) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test( $email );
}


function infoConfirm( _id){
    if(!$(  _id ).prop('checked')){
        $( _id ).addClass('error');
        kontaktok = false;
    }
}



function displayConfirm(){
    if($('#kontaktform').length>0){
        var procSuc = getParameterByName('status');
        if(procSuc != '' && procSuc != undefined){
            var offSet = 200;
            if(procSuc =='confirm'){
                $('#confirmDialog').show();
                scrollToY( $('#confirmDialog').offset().top - offSet );
            }else if(procSuc =='error'){
                $('#errorDialog').show();
                scrollToY( $('#errorDialog').offset().top - offSet );
            }
        }
    }

}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function scrollToY( _y){
    $('body, html').animate({scrollTop:_y}, 'slow');
}
